import { openNotificationWithIcon } from '../../../../../utils/notification.helper'
import React from 'react'
import { useCreateConceptualLabelMutation } from '../../../../../store/apis/conceptual-label.api'
import ConceptualLabelForm from '../ConceptualLabelForm'
import { useSelector } from 'react-redux'
import conceptualLabelSelectors from '../../../../../store/selectors/conceptual-label.selectors'

const CreateConceptualLabelForm = ({ onSuccess }) => {
    const [createConceptualLabel, createConceptualLabelResult] = useCreateConceptualLabelMutation()
    const initialValues = useSelector(conceptualLabelSelectors.createFormInitialValues)

    const onSubmit = async values => {
        const response = await createConceptualLabel({
            name: values.name,
            description: values.description,
            disciplineId: values.disciplineId,
            source: values.source,
            parentId: values.parentId,
            typeId: values.typeId,
        })

        if ('data' in response) {
            openNotificationWithIcon('success', 'Conceptual label created successfully')
            onSuccess()
        }
    }

    return (
        <ConceptualLabelForm
            onSubmit={onSubmit}
            error={createConceptualLabelResult?.error}
            loading={createConceptualLabelResult?.isLoading}
            actionName='Create'
            initialValues={initialValues}
        />
    )
}

export default CreateConceptualLabelForm
